import { render, staticRenderFns } from "./FormEspecialidade.vue?vue&type=template&id=af36b6f8"
import script from "./FormEspecialidade.vue?vue&type=script&lang=js"
export * from "./FormEspecialidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports